import { twMerge } from 'tailwind-merge';
import {
  trackerHueClasses,
  trackerIconComponent,
  type TrackerHue,
  type TrackerIcon,
} from '../model/appearance';

const SIZES = {
  sm: { tile: 'size-6 rounded-sm', icon: 'size-3.5' },
  md: { tile: 'size-10 rounded-lg', icon: 'size-4.5' },
  lg: { tile: 'size-12 rounded-sm', icon: 'size-5' },
} as const;

/** A tracker's icon on a tile in its colour. Decorative: the tracker's name always sits beside it. */
export function TrackerIconTile({
  icon,
  hue,
  size,
  className,
  'data-testid': dataTestId,
}: {
  icon: TrackerIcon;
  hue: TrackerHue;
  size: keyof typeof SIZES;
  className?: string;
  'data-testid'?: string;
}) {
  const Icon = trackerIconComponent(icon);
  const colours = trackerHueClasses(hue);
  return (
    <span
      aria-hidden="true"
      data-testid={dataTestId}
      className={twMerge(
        'flex shrink-0 items-center justify-center',
        SIZES[size].tile,
        colours.tile,
        colours.foreground,
        className,
      )}
    >
      <Icon className={SIZES[size].icon} />
    </span>
  );
}
